<template>
  <div style="height: 100%;background-color: white" v-loading="loading" element-loading-text="加载中，请耐心等待。">
    <div style="padding-top:20px;height: 50px;margin: 0 20px">
      <span>时间：</span>
      <el-date-picker v-fixZoom
        :clearable="false"
        v-model="monthVal"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="primary" @click="getTableData">查询</el-button>
      <el-button icon="el-icon-download" type="success" @click="getAllDown">导出</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);margin: 0 20px;overflow-y: auto;">
      <el-table v-loading="tableLoading" element-loading-text="加载中，请耐心等待。"
        :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="personname"
          label="人名"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="apply_name"
          label="申请人"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="apply_time"
          label="申请时间"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <strong v-if="scope.row.check_type === 0" style="color: #909399;">未审核</strong>
            <strong v-if="scope.row.check_type === 1" style="color: #67C23A">已通过</strong>
            <strong v-if="scope.row.check_type === 2" style="color: #F56C6C">已拒绝</strong>
          </template>
        </el-table-column>
        <el-table-column
          prop="approve_name"
          label="审批人"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="approve_time"
          label="审批时间"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="approve_remark"
          label="审批备注"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="90"
          align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openCheck(scope.row)" plain>详情审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="checkShow" v-if="checkShow" width="1100px"
      :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>审核信息</span> </div>
        <div class="line-title"></div>
        <check-msg :checkObj="checkObj" @changeCheck="changeCheck"></check-msg>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {querycheckinfo} from '../../api/alarmservice'
import checkMsg from './childComponents/checkMsg'
import {queryfrequency, queryproject} from '../../api/serviceObject'
import {querydiseasename} from '../../api/home'
export default {
  name: 'checkData',
  components: {checkMsg},
  data () {
    return {
      loading: true,
      monthVal: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      tableLoading: false,
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      checkShow: false,
      checkObj: {
        projects: [],
        frequencys: [],
        diseasenames: [],
        row: ''
      },
      bloodTypes: [
        {name: 'A型', value: 1},
        {name: 'B型', value: 2},
        {name: 'AB型', value: 3},
        {name: 'O型', value: 4},
        {name: 'A-型', value: 5},
        {name: 'B-型', value: 6},
        {name: 'AB-型', value: 7},
        {name: 'O-型', value: 8}
      ],
      downArr: [],
      isLabel: '',
      diseasenames: [],
      frequencys: [],
      projects: []
    }
  },
  created () {
    const end = new Date()
    const start = new Date()
    start.setDate(1)
    // console.log(11, start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd'))
    this.monthVal = [start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd')]
    this.getTimeObj()
    this.getProjects()
    this.getFrequency()
    this.getDisease()
    this.getTableData()
    let moduletag = this.$store.state.user.moduletag
    if (moduletag === 1) {
      this.isLabel = '所属家庭'
    } else if (moduletag === 2) {
      this.isLabel = '所属房间'
    } else {
      this.isLabel = '家庭/房间'
    }
  },
  methods: {
    // 患病类型
    getDisease () {
      querydiseasename().then(res => {
        this.diseasenames = res.data.diseasenames
        this.checkObj.diseasenames = res.data.diseasenames
      }).catch(() => {})
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryproject(data).then(res => {
        this.projects = res.data.projects
        this.checkObj.projects = res.data.projects
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询频率
    getFrequency () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.checkObj.frequencys = res.data.frequencys
      }).catch(() => {})
    },
    getTableData () {
      // console.log(this.monthVal)
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      // return
      let data = {
        from: this.monthVal[0] + ' 00:00:00',
        to: this.monthVal[1] + ' 23:59:59'
      }
      if (!this.loading) {
        this.tableLoading = true
      }
      querycheckinfo(params, data).then(res => {
        this.loading = false
        this.tableLoading = false
        this.totalCells = res.data.cnt
        this.tableData = res.data.checkinfo
      }).catch(() => {
        this.loading = false
        this.tableLoading = false
      })
      // console.log(this.monthVal)
    },
    openCheck (obj) {
      this.checkObj.row = obj
      this.checkShow = true
    },
    changeCheck () {
      this.getTableData()
      this.checkShow = false
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    },
    getAllDown () {
      let params = {
        page: 1,
        size: this.totalCells
      }
      // return
      let data = {
        from: this.monthVal[0] + ' 00:00:00',
        to: this.monthVal[1] + ' 23:59:59'
      }
      querycheckinfo(params, data).then(res => {
        this.getDownData(res.data.checkinfo)
      }).catch(() => {})
    },
    getDownData (arr) {
      this.downArr = []
      for (let i = 0; i < arr.length; i++) {
        let type = arr[i].check_type
        if (arr[i].check_type === 0) {
          type = '未审核'
        } else if (arr[i].check_type === 1) {
          type = '已通过'
        } else if (arr[i].check_type === 2) {
          type = '已拒绝'
        }
        let obj = {
          personname: arr[i].personname,
          apply_name: arr[i].apply_name,
          apply_time: arr[i].apply_time,
          check_type: type,
          approve_name: arr[i].approve_name,
          approve_time: arr[i].approve_time,
          approve_remark: arr[i].approve_remark,
          detail: this.getOldNew(arr[i])
        }
        this.downArr.push(obj)
      }
      if (this.downArr.length === 0) {
        this.$message({
          type: 'info',
          message: '暂无数据导出。',
          duration: 2000
        })
      } else {
        this.download2()
      }
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getBloodTypeName (val) {
      let name = val
      for (let i = 0; i < this.bloodTypes.length; i++) {
        if (val === this.bloodTypes[i].value) {
          name = this.bloodTypes[i].name
        }
      }
      return name
    },
    getDiseaseName (disease) {
      let name = '健康'
      if (disease !== '') {
        name = ''
        let arr = disease.split(',')
        let ids = []
        for (let i = 0; i < arr.length; i++) {
          ids.push(parseInt(arr[i]))
        }
        for (let i = 0; i < ids.length; i++) {
          name = this.getName(ids[i]) + ',' + name
        }
      }
      return name
    },
    getName (id) {
      for (let i = 0; i < this.diseasenames.length; i++) {
        if (parseInt(id) === this.diseasenames[i].id) {
          return this.diseasenames[i].name
        }
      }
    },
    getFrequencyName (id) {
      let name = id
      for (let i = 0; i < this.frequencys.length; i++) {
        if (id === this.frequencys[i].id) {
          name = this.frequencys[i].frequency
        }
      }
      return name
    },
    getProjectName (id) {
      let name = id
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          name = this.projects[i].projectname
        }
      }
      return name
    },
    getIsDead (val) {
      let name = val
      if (val === 1) {
        name = '离世'
      } else if (val === 0) {
        name = '在世'
      }
      return name
    },
    getOldNew (obj) {
      let detail = ''
      let isHomePerson = 0 // 0 其他 1 家 2 人
      let changeinfo = JSON.parse(obj.changeinfo.toString())
      if (changeinfo.homeinfo !== '') {
        isHomePerson = 1
      }
      if (changeinfo.personinfo !== '') {
        isHomePerson = 2
      }
      let oldMsg = {
        home: obj.home,
        person: obj.person
      }
      let newMsg = {
        home: changeinfo.homeinfo,
        person: changeinfo.personinfo
      }
      if (isHomePerson === 0) {} else if (isHomePerson === 1) {
        detail = '旧_所属区域：' + oldMsg.home.orglevelname + '，新_所属区域：' + newMsg.home.orglevelname + '，旧_' + this.isLabel + '：' + oldMsg.home.address + '，新_' + this.isLabel + '：' + newMsg.home.address
      } else if (isHomePerson === 2) {
        detail = '旧_姓名：' + oldMsg.person.name + '，新_姓名：' + newMsg.person.name + '，旧_性别：' + this.getSex(oldMsg.person.sex) + '，新_性别：' + this.getSex(newMsg.person.sex) +
          '，旧_籍贯：' + oldMsg.person.nativeplace + '，新_籍贯：' + newMsg.person.nativeplace + '，旧_民族：' + oldMsg.person.nation + '，新_民族：' + newMsg.person.nation +
          '，旧_出生日期：' + oldMsg.person.birthday + '，新_出生日期：' + newMsg.person.birthday + '，旧_身份证号：' + oldMsg.person.idcard_num + '，新_身份证号：' + newMsg.person.idcard_num +
          '，旧_联系方式：' + oldMsg.person.phone + '，新_联系方式：' + newMsg.person.phone + '，旧_接听时间段：' + oldMsg.person.timelist + '，新_接听时间段：' + newMsg.person.timelist +
          '，旧_血型：' + this.getBloodTypeName(oldMsg.person.blood_type) + '，新_血型：' + this.getBloodTypeName(newMsg.person.blood_type) + '，旧_健康状态：' + this.getDiseaseName(oldMsg.person.have_disease) + '，新_健康状态：' + this.getDiseaseName(newMsg.person.have_disease) +
          '，旧_服务频率：' + this.getFrequencyName(oldMsg.person.frequencyid) + '，新_服务频率：' + newMsg.person.phone + '，旧_所属项目：' + this.getProjectName(oldMsg.person.projectid) + '，新_所属项目：' + this.getProjectName(newMsg.person.projectid) +
          '，旧_特殊情况：' + oldMsg.person.circumstances + '，新_特殊情况：' + newMsg.person.circumstances + '，旧_生命体征：' + this.getIsDead(oldMsg.person.is_dead) + '，新_生命体征：' + this.getIsDead(newMsg.person.is_dead)
      }
      return detail
    },
    download2 () {
      let arr = this.downArr
      let filename = '数据审批'
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['人名', '申请人', '申请时间', '状态', '审批人', '审批时间', '审批备注', '审批详情']
        const filterVal = ['personname', 'apply_name', 'apply_time', 'check_type', 'approve_name', 'approve_time', 'approve_remark', 'detail']
        const list = arr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: filename
        })
      })
      // setTimeout(() => {
      //   this.$message.closeAll()
      // }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/checkData.vue